import { defineMessages } from 'react-intl'

const translations = defineMessages({
  summaryOrderTotal: {
    defaultMessage: 'Total*',
    id: 'msp.account.subscriptions.detail.summary.order_total'
  },
  vary: {
    defaultMessage: '*final total may vary due to promotions',
    id: 'msp.account.subscriptions.detail.summary.vary'
  }
})

export default translations
